import { render, staticRenderFns, recyclableRender, components } from "./u-transition.vue?vue&type=template&id=39e33bf2&scoped=true&"
var renderjs
import script from "./u-transition.vue?vue&type=script&lang=js&"
export * from "./u-transition.vue?vue&type=script&lang=js&"
import style0 from "./u-transition.vue?vue&type=style&index=0&id=39e33bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e33bf2",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-transition/u-transition.vue"
export default component.exports